import { DrawApi } from '@apply/api';
import DateBox from 'devextreme-react/date-box';
import dayjs from 'dayjs';

interface IEquityMetOnProps {
    onEquityMetOnChange: (newValue: Date) => void;
    drawBudget?: DrawApi.IDrawBudget;
    isAdmin: boolean;
}

export const EquityMetOn = ({ drawBudget, isAdmin, onEquityMetOnChange }: IEquityMetOnProps): JSX.Element => {
    return (
        <div>
            <label htmlFor='inspectionOrdered'>Equity Met On:</label>
            {isAdmin ? (
                <DateBox
                    className='draw-header-input'
                    value={drawBudget?.equityMetOn}
                    onValueChange={(date) => onEquityMetOnChange(date)}
                />
            ) : (
                <p>{drawBudget?.equityMetOn ? dayjs(drawBudget?.equityMetOn).format('M/D/YY') : '-'}</p>
            )}
        </div>
    );
};
